import { Button } from 'antd'
import LinesImportCont from '../../../../components/Purchasing/Order/ImportLines/LinesImportCont'
import CustomTable from '../../../../elements/Table/CustomTable'
import { get } from 'lodash'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'

function FeeList(props) {
  const { list, onShow, fetching, fetch, order, isUpdatable } = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'ReqLine ID',
      accessor: 'reqLine._id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'No',
      accessor: 'no',
      width: 40,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Name',
      accessor: 'name',
      width: 400,
    },

    {
      Header: 'Rate',
      accessor: 'rate',
    },
    {
      Header: 'Unit',
      accessor: 'unit',
    },
    {
      Header: 'UOM',
      accessor: 'uom.code',
    },
    {
      Header: 'Tax Rate',
      accessor: 'tax.rate',
    },
    {
      Header: 'Tax Type',
      accessor: 'tax.type',
    },
    {
      Header: 'Amount (EX)',
      accessor: 'amount.net',
      hideable: true,
      hideDefault: false,
      Footer: SumFooter,
    },
    {
      Header: 'Amount (tax)',
      accessor: 'amount.tax',
      hideable: true,
      hideDefault: true,
      Footer: SumFooter,
    },
    {
      Header: 'Amount (INC)',
      accessor: 'amount.gross',
      hideable: true,
      hideDefault: true,
      Footer: SumFooter,
    },
    {
      Header: 'Ready',
      accessor: 'ready',
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Req Group',
      accessor: 'reqs.code',
      Cell: ({ original, value }) => {
        return (
          <Link
            target={'_blank'}
            to={`/purchasing/requisitions/${get(original, 'reqs._id', '').replace(
              'reqs/',
              '',
            )}/update`}
            style={{ marginLeft: '10px' }}>
            {value || get(original, 'reqs.title') || get(original, 'reqs._id')}
          </Link>
        )
      },
      width: 120,
    },
    /*{
      Header: 'Dropship',
      accessor: 'dropship',
    },*/
  ]

  return (
    <Fragment>
      <CustomTable
        data={list}
        CreateButton={() => (
          <>
            <Button
              type={'primary'}
              size="small"
              icon={'plus'}
              disabled={!isUpdatable}
              onClick={onShow}>
              Add New Fee
            </Button>
            <LinesImportCont {...{ order, fetch, isUpdatable }} />
          </>
        )}
        columns={columns}
        fetching={fetching}
        fetch={fetch}
        defaultSorted={[
          {
            id: 'no',
            desc: false,
          },
        ]}
        style={{ marginTop: 10 }}
      />
    </Fragment>
  )
}

export default FeeList
